import * as React from 'react';
import * as autoBind from 'react-autobind';
import Header from '../Header/Header';
import FeedbackUserService from '../../services/FeedbackUserService/FeedbackUserService';
import UrlParser from '../../utils/UrlParser/UrlParser';
import Strings from '../../globals/Strings';
import {ControlButton, TscButtonType} from '@techsmith/tsc-cloud-style-guide';
import TermsOfServiceText from '../TermsOfService/TermsOfServiceText';
import HeaderLogo from '../HeaderLogo/HeaderLogo';
import AccountWidgetContainer from '../AccountWidgetContainer/AccountWidgetContainer';
import Constants from '../../globals/Constants';
import {RouteComponentProps, withRouter} from 'react-router';

export class TermsOfServicePrompt extends React.Component<RouteComponentProps, {}> {
   constructor(props: RouteComponentProps) {
      super(props);
      autoBind(this);
   }

   async acceptTermsOfService() {
      const {history} = this.props;
      await FeedbackUserService.postAcceptTermsOfService();

      const previousLocation: string = decodeURIComponent(UrlParser.getUrlQueryParam(location.search, 'redirect'));

      if (!previousLocation) {
         history.replace(Constants.siteLinks.dashboard);
      } else {
         history.replace(previousLocation);
      }
   }

   render() {
      const headerMiddle = <HeaderLogo linkToRoot={false}/>;
      const headerRight = <AccountWidgetContainer/>;

      return (
         <div className="terms-of-service-container">
            <Header middleSection={headerMiddle} rightSection={headerRight}/>
            <div className="terms-of-service-wrapper">
               <h1 className="title">{Strings.termsOfService.title}</h1>
               <div className="terms-of-service">
                  <h2 className="terms-title">{Strings.termsOfService.subTitle}</h2>
                  <p className="description">{Strings.termsOfService.prompt}</p>
                  <TermsOfServiceText />
                  <div className="terms-of-service-actions">
                     <ControlButton buttonType={TscButtonType.secondary}
                                    label={Strings.termsOfService.button.print}
                                    onClick={window.print} />
                     <ControlButton testId="accept-tos-button"
                                    buttonType={TscButtonType.primary}
                                    label={Strings.termsOfService.button.accept}
                                    onClick={this.acceptTermsOfService} />
                  </div>
               </div>
            </div>
         </div>
      );
   }
}

export default withRouter(TermsOfServicePrompt);
